import { TAB_NAMES } from "@/organisms/Drawers/const"
import { makeLazyEvpTab } from "../makeLazyEvpTab"

const RemediationTab = makeLazyEvpTab(TAB_NAMES.remediation, () =>
  import("./RemediationTabTriageDrawer").then((m) => ({
    default: m.RemediationTabTriageDrawer
  }))
)

export default RemediationTab
